import { createSlice } from "@reduxjs/toolkit";

export const commonSlice = createSlice({
  name: "commonReducer",
  initialState: {
    value: true,
  },
  reducers: {
    updateRedux: (state, data) => {
      state[data.payload.key] = data.payload.value;
    },
  },
});
export const { updateRedux } = commonSlice.actions;

export const value = (state) => state.commonReducer.value;

// LOADINGS
export const login_loading = (state) => state.commonReducer.login_loading;
// project data
export const project_data = (state ) => state.commonReducer.project_data;

export const all_employees = (state) => state.commonReducer.all_employees;
export const employee_list_loading = (state) =>
  state.commonReducer.employee_list_loading;
export const employees_page_details = (state) =>
  state.commonReducer.employees_page_details;
export const add_employee_loading = (state) =>
  state.commonReducer.add_employee_loading;
export const add_project_loading = (state) =>
  state.commonReducer.add_project_loading;
export const project_loading = (state) => state.commonReducer.project_loading;
// export const value = (state ) => state.commonReducer.value;
// export const value = (state ) => state.commonReducer.value;
// export const value = (state ) => state.commonReducer.value;
// export const value = (state ) => state.commonReducer.value;
// export const value = (state ) => state.commonReducer.value;

export default commonSlice.reducer;
